import { Injectable } from "@angular/core"
@Injectable()
export class FeatureFlagsService {
    get classesFeatureFlag(): boolean {
        return window["PBSLM"].FEATURE_FLAGS.NEW_CLASSES_REDESIGN
    }
}
